import { debounce } from 'throttle-debounce'

class Header {
  constructor(element) {
    this.header = element
    this.toggleBtn = this.header.querySelector('.header__toggle')
    this.isOpen = false

    this.toggle = this.toggle.bind(this)
    this.setFixedNav = this.setFixedNav.bind(this)

    this.init()
  }

  toggle(e) {
    e.preventDefault()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.header.classList.add('header--open')
    this.isOpen = true
  }

  close() {
    this.header.classList.remove('header--open')
    this.isOpen = false
  }

  setFixedNav() {
    this.scrollPos = window.scrollY || window.pageYOffset

    if (this.scrollPos > 120) {
      this.header.classList.add('header--fixed')
    } else {
      this.header.classList.remove('header--fixed')
    }
  }

  init() {
    this.setFixedNav()
    this.toggleBtn.addEventListener('click', debounce(200, this.toggle))
    window.addEventListener('scroll', this.setFixedNav)
  }
}

const headerInit = {
  init() {
    const elements = document.querySelectorAll('.header')
    Array.from(elements).map(element => new Header(element))
  },
}

export default headerInit
